import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

// TODO This type definition is incomplete
export type EmployeePerformanceGoals = {
  totScore: number;
};

export const getEmployeePerformanceGoals = async (
  employeeId: number,
): Promise<EmployeePerformanceGoals[]> =>
  fetchFromOldApi(
    `/json/performance/goals/employee/${employeeId}/evaluations`,
  ).then((r) => r.json());

type UseGetEmployeePerformanceGoalsOutput = Omit<
  UseSWROutput<EmployeePerformanceGoals[]>,
  'data'
> & {
  performanceGoals: EmployeePerformanceGoals[];
};

export const useGetEmployeePerformanceGoals = (
  args: {
    employeeId?: number;
  },
  swrConfig?: SWRConfiguration,
): UseGetEmployeePerformanceGoalsOutput => {
  const { employeeId } = args;

  const { data, ...rest } = useSWR(
    !!employeeId ? ['getEmployeePerformanceGoals', employeeId] : null,
    ([_key, employeeId]: [string, number]) =>
      getEmployeePerformanceGoals(employeeId),
    swrConfig,
  );

  return {
    performanceGoals: data ?? [],
    ...rest,
  };
};
